import axios from '@/api/config';

const plan = {
    getPlanList(data) {
      return axios.get(`${process.env.BASE_URL}/plan/getPlanList`, {params: data});
    },
    getAgentPlanList(data) {
      return axios.get(`${process.env.BASE_URL}/plan/getAgentPlanList`, {params: data});
    },
    getPlan(data) {
      return axios.get(`${process.env.BASE_URL}/plan/getPlan`, {params: data});
    },
    addPlan(data) {
        return axios.post(`${process.env.BASE_URL}/plan/addPlan`, data);
    },
    pageList(data) {
        return axios.post(`${process.env.BASE_URL}/plan/pageList`, data);
    },
    deletePlan(data) {
        return axios.delete(`${process.env.BASE_URL}/plan/deletePlan`, {data:data});
    },
    updatePlan(data) {
        return axios.put(`${process.env.BASE_URL}/plan/updatePlan`, data);
    },
    getPlanDetail(data) {
        return axios.get(`${process.env.BASE_URL}/plan/getPlanDetail`, {params:data});
    },
}

export default plan;



// WEBPACK FOOTER //
// ./src/api/plan.js